import PropTypes from 'prop-types';

export default function CheckboxHeader({ col }) {
  return (
    <label className="checkbox-column">
      <input
        type="checkbox"
        onChange={() => col.headerConfig.onClick(col, !col.headerConfig.value)}
        checked={col.headerConfig.value}
        disabled={col.headerConfig.disabled}
      />
    </label>
  );
}

CheckboxHeader.defaultWidth = 40;

CheckboxHeader.propTypes = {
  col: PropTypes.shape({
    headerConfig: PropTypes.shape({
      value: PropTypes.bool.isRequired,
      onClick: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
};
